"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTransparencyChart = void 0;
var React = require("react");
var recharts_1 = require("recharts");
var PriceTransparencyChart = /** @class */ (function (_super) {
    __extends(PriceTransparencyChart, _super);
    function PriceTransparencyChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (entry, index) { return _this.props.setActiveIndex(index); };
        return _this;
    }
    PriceTransparencyChart.prototype.render = function () {
        var _this = this;
        var max = Math.max.apply(Math, this.props.data.map(function (value) { return Math.abs(value.value); })) * 1.1;
        return (React.createElement("div", { className: "price-transparency-chart " + this.props.className },
            React.createElement("div", { className: "start-price-mobile text-right" },
                React.createElement("span", null, "\u2013 \u2013 \u2013"),
                " Starting price for everyone"),
            React.createElement("div", { className: "d-flex" },
                React.createElement("div", { className: "legend d-flex justify-content-between flex-column text-right pr-md-2" },
                    React.createElement("div", { className: "high-price" }, "Higher price"),
                    React.createElement("div", { className: "start-price-desktop" }, "Starting price for everyone"),
                    React.createElement("div", { className: "low-price" }, "Lower price")),
                React.createElement("div", { className: "chart border-left border-dark" },
                    React.createElement(recharts_1.ResponsiveContainer, { height: 250 },
                        React.createElement(recharts_1.BarChart, { data: this.props.data, margin: { top: 15, right: 0, bottom: 15, left: 0 } },
                            React.createElement.apply(React, __spreadArray([recharts_1.Bar, { dataKey: "value", fill: "white", radius: [15, 15, 0, 0], isAnimationActive: false, onClick: this.handleClick }, React.createElement(recharts_1.LabelList, { dataKey: "name", position: "centerBottom" })], this.props.data.map(function (entry, index) { return (React.createElement(recharts_1.Cell, { key: "bar-".concat(index), className: index === _this.props.activeIndex ? "".concat(entry.name, "-bar-active") : "".concat(entry.name, "-bar"), cursor: "pointer" })); }), false)),
                            React.createElement(recharts_1.YAxis, { domain: [-max, max], tickCount: 3, interval: 1, hide: true }),
                            React.createElement(recharts_1.CartesianGrid, { vertical: false }),
                            React.createElement(recharts_1.ReferenceLine, { y: 0, isFront: true })))))));
    };
    return PriceTransparencyChart;
}(React.Component));
exports.PriceTransparencyChart = PriceTransparencyChart;
//# sourceMappingURL=PriceTransparencyChart.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/priceTransparency/PriceTransparencyChart.js
// module id = 2609
// module chunks = 0